<template>
  <BaseTable
      :title="$t('user')"
      :subtractHeight="subtractHeight"
      :height="height"
      dto-model="UserListQueryDTO"
      dto-save-list-model="UserSaveListCommandDTO"
      store-name="UserTable"
      new-item-component="UserItem"
      new-item-pass="/User/UserItem"
      :lang-dictionary="function(text) {return $t(text)}"
      fixed-header
  >
<!--    <template v-slot:top.right="instance"><span></span></template>-->
    <template v-slot:item.username="{ item }">
      <router-link :to="{name:'UserItem', params: { itemUid: item.uid}}">
        <span v-if="item.username">{{ item.username }}</span>
        <span v-else>****</span>
      </router-link>
    </template>
    <template v-slot:item.groups="{ item }">
      <span v-if="item.groups.length === 0"></span>
      <v-chip small outlined v-for="(row,i) in item.groups" :key="i" dense class="mx-1">
        {{ row.name }}
      </v-chip>
    </template>
    <template v-slot:item.human_user="{ item }">
      <span v-if="!!item.human_user"> {{item.human_user.user}}</span>
    </template>
    <template v-slot:item.employee_number="{ item }">
      <span v-if="!!item.human_user"> {{item.human_user.employee_number}}</span>
    </template>
  </BaseTable>
</template>

<script>

import BaseTable from "@/components/Base/BaseTable";
import BaseDeleteIcon from "@/components/Base/BaseDeleteIcon";

export default {
  name: 'UserTable',
  props: {
    subtractHeight: {type: [Number], default: 140},
    height: {type: [Number], default: window.innerHeight},
    modalDialog: {type: [Boolean], default: false}
  },

  components: {
    BaseTable,
    BaseDeleteIcon,
  },

  computed: {},

  methods: {},

  async mounted() {
    // console.log('mounted')
  },

  created() {
  },

  destroyed() {
  },

  beforeCreate() {
  },

  beforeDestroy() {
  },

  data() {
    return {}
  }
}
</script>

<style>
.row_even {
}
</style>

<i18n>
{
  "en": {
    "user": "User",
    "columns": {
      "deleted": " ",
      "edit": " ",
      "id": "ID",
      "username": "Username",
      "shortname": "Shortname",
      "human_user": "Human user",
      "employee_number": "Employee",
      "first_name": "First name",
      "last_name": "Last name",
      "email": "Email",
      "is_staff": "Is staff",
      "is_active": "Is active",
      "is_superuser": "Is superuser",
      "last_login": "Last logon",
      "date_join": "Date join",
      "groups": "Groups"
    }
  },
  "de": {
    "user": "Benutzer",
    "columns": {
      "deleted": " ",
      "edit": " ",
      "id": "ID",
      "username": "Username",
      "shortname": "Shortname",
      "human_user": "Human user",
      "employee_number": "Employee",
      "first_name": "First name",
      "last_name": "Last name",
      "email": "Email",
      "is_staff": "Is staff",
      "is_active": "Is active",
      "is_superuser": "Is superuser",
      "last_login": "Last logon",
      "date_join": "Date join",
      "groups": "Groups"
    }
  }
}
</i18n>
